import React, { useState, useEffect } from 'react'
import { formatMoney, moneyToNumber, toMoney } from 'src/utils/formatter';

export const Counter = ({ amount }) => {

    const [amountToShow, setAmountToShow] = useState(0)

    const counting = () => {
        const data = +moneyToNumber(document.getElementById("contador").innerHTML);
    
        const time = amount / 15;
    
        if (data < amount) {
          setAmountToShow(Math.ceil(data + time))
          setTimeout(counting, 1);
        } else {
          setAmountToShow(amount)
        }
      }
    
    const subtracting = () => {
      const data = +moneyToNumber(document.getElementById("contador").innerHTML);
  
      const time = data / 25;
  
      if (data > amount) {
        setAmountToShow(Math.ceil(data - time));
        setTimeout(counting, 1);
      } else {
        setAmountToShow(amount);
      }
    }

    useEffect(() => {
      if (amount > amountToShow) counting()
      if (amount < amountToShow) subtracting()
    }, [amount])  

    return (
        <div className="d-flex mr-5">
            <div>Total:</div>
            <div className="ml-2" id="contador">
            {toMoney(amountToShow) || 0}
            </div>
        </div>
    )
}